var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumpers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 22,
    viewBox: "0 0 185 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5008_42339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.464 7.6543H5.26562V9.08954H177.464V7.6543Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 14.8301H5.26562V16.2653H177.464V14.8301Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 10.0469H5.26562V11.4821H177.464V10.0469Z",
    fill: "#4A3A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 17.2227H5.26562V18.6579H177.464V17.2227Z",
    fill: "#4A3A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 12.4375H5.26562V13.8727H177.464V12.4375Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 19.6152H5.26562V21.0504H177.464V19.6152Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 7.17578H1.91406V9.56781H7.17566V7.17578Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 14.3516H1.91406V16.7436H7.17566V14.3516Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 9.56836H1.91406V11.9604H7.17566V9.56836Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 16.7441H1.91406V19.1362H7.17566V16.7441Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 11.9609H1.91406V14.353H7.17566V11.9609Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 19.1367H1.91406V21.5287H7.17566V19.1367Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 9.56836H182.719V7.17633H177.457V9.56836Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 16.7441H182.719V14.3521H177.457V16.7441Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 11.9609H182.719V9.56891H177.457V11.9609Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 19.1367H182.719V16.7447H177.457V19.1367Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 14.3516H182.719V11.9595H177.457V14.3516Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 21.5273H182.719V19.1353H177.457V21.5273Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 8.13281H0V8.61121H2.39163V8.13281Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 15.3086H0V15.787H2.39163V15.3086Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 10.5254H0V11.0038H2.39163V10.5254Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 17.7012H0V18.1796H2.39163V17.7012Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 12.918H0V13.3964H2.39163V12.918Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 20.0938H0V20.5722H2.39163V20.0938Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 8.61133H184.633V8.13294H182.241V8.61133Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 15.7871H184.633V15.3087H182.241V15.7871Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 11.0039H184.633V10.5255H182.241V11.0039Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 18.1797H184.633V17.7013H182.241V18.1797Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 13.3945H184.633V12.9161H182.241V13.3945Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 20.5703H184.633V20.0919H182.241V20.5703Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 0.478516H5.26562V1.91373H177.464V0.478516Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 2.87109H5.26562V4.3063H177.464V2.87109Z",
    fill: "#4A3A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.464 5.26172H5.26562V6.69696H177.464V5.26172Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 0H1.91406V2.39203H7.17566V0Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 2.39258H1.91406V4.78461H7.17566V2.39258Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17566 4.7832H1.91406V7.17523H7.17566V4.7832Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 2.39258L182.719 2.39258V0.000548363L177.457 0.000548363V2.39258Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 4.7832L182.719 4.7832V2.39117L177.457 2.39117V4.7832Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457 7.17578L182.719 7.17578V4.78375H177.457V7.17578Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 0.957031H0V1.43543H2.39163V0.957031Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 3.34766H0V3.82605H2.39163V3.34766Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163 5.74023H0V6.21863H2.39163V5.74023Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 1.43555L184.633 1.43555V0.957154L182.241 0.957154V1.43555Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 3.82812L184.633 3.82812V3.34973L182.241 3.34973V3.82812Z",
    fill: "#234A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.241 6.21875H184.633V5.74036H182.241V6.21875Z",
    fill: "#234A30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5008_42339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpers);
export default __webpack_public_path__ + "static/media/jumpers.88a9537f5d6d3630680310fa77f0260d.svg";
export { ForwardRef as ReactComponent };